import {
  RESET_UI_STATE,
  STR_MUTATION_UI_SET_CART_ICON_SHOWING_ORDER_INFO,
  STR_MUTATION_FULLSCREEN_LOADING,
  SHOW_FORGOT_PASSWORD_DIALOG,
  SHOW_ADD_CHILDREN_TO_ORDER_DIALOG,
  SET_CONFIG_OPTIONS
} from "./mutation-types";
export default {
  [RESET_UI_STATE](state, inDefaultState) {
    state = Object.assign({}, state, inDefaultState);
  },
  [STR_MUTATION_UI_SET_CART_ICON_SHOWING_ORDER_INFO](state, inBShowOrderInfo) {
    state.cartIconIsShowingOrderInfo = inBShowOrderInfo;
  },
  [STR_MUTATION_FULLSCREEN_LOADING](state, inBLoading) {
    state.fullScreenLoading = inBLoading;
  },
  [SHOW_FORGOT_PASSWORD_DIALOG](state, bShowDlg) {
    state.dialogs.showForgotPasswordDialog = bShowDlg;
  },
  [SHOW_ADD_CHILDREN_TO_ORDER_DIALOG](state, mode) {
    state.dialogs.showAddChildrenToOrderDialog = mode;
  },
  [SET_CONFIG_OPTIONS](state, inConfigOptions) {
    state.config = Object.assign({}, inConfigOptions);
  }
};
